import { styled } from '@glitz/react';
import { createMinLargeViewportDecorator } from 'webapp/viewport';

export const headingDecorator = styled(createMinLargeViewportDecorator({ fontSize: t => t.fontSize.l }), {
  fontFamily: t => t.fontFamily?.secondary,
  textTransform: t => t.heading?.textTransform,
  fontSize: t => t.fontSize.s,
  fontWeight: t => t.heading?.fontWeight,
});
